'use client';
import * as Styled from './styled';
import ProcessingIcon from '@/ui/ProcessingIcon';

const getEvalStatusType = (evalStatusText: string) => {
  switch (evalStatusText) {
    case 'waiting':
      return 'notice';
    case 'error':
      return 'negative';
    case 'success':
      return 'positive';
  }
};

const MaybeEvalStatus: React.FC<{ value: string; children: React.ReactNode }> = ({ value, children }) => {
  if (typeof value !== 'string') {
    return children;
  }

  const isEvalStatus = !!value && value.startsWith('__oxen_eval_status_');
  const evalStatusText = isEvalStatus ? value.split('__oxen_eval_status_')[1] : undefined;
  const evalStatusType = evalStatusText ? getEvalStatusType(evalStatusText) : undefined;
  return isEvalStatus ? (
    <Styled.EvalProcessing title={evalStatusText}>
      <ProcessingIcon type={evalStatusType || 'information'} /> {evalStatusText}
    </Styled.EvalProcessing>
  ) : (
    children
  );
};

export default MaybeEvalStatus;
